module.exports = __webpack_public_path__ + "img/shs_metalwarmint.5af0bab.png";